import { HtmlRenderer, Parser } from 'commonmark';
import { capitalize } from 'lodash';

export const camelToTitleCase = (camelStr: string): string => {
  // Replace the camel case boundaries with space and convert the first letter of each word to uppercase
  const result = camelStr
    .replace(/([A-Z])/g, ' $1') // Insert a space before each uppercase letter
    .toLowerCase(); // Convert the entire string to lowercase

  return result.charAt(0).toUpperCase() + result.slice(1); // Capitalize the first letter of the result
};

export const snakeToSentenceCase = (snakeStr?: string | null): string => {
  if (!snakeStr) return '';

  return snakeStr.split('_').map(capitalize).join(' ');
};

export const stringToHTML = (str: string): string | TrustedHTML => {
  const reader = new Parser();
  const writer = new HtmlRenderer();

  return writer.render(reader.parse(str));
};

interface PluralizeParams {
  count: number;
  singular: string;
  plural?: string;
}

export const pluralize = (params: PluralizeParams): string => {
  const { count, singular, plural = `${singular}s` } = params;

  return count === 1 ? singular : plural;
};
